import React from 'react';
import axios from 'axios';
import endpoints from '../define/endpoints';

export function useCoreCategories(ignoreCategories = []) {
  const [categories, setCategories] = React.useState([]);

  React.useEffect(() => {
    (async function () {
      const locale = window.freedomeConfig.locale;
      const storageKey = `core_categories_${locale}_${ignoreCategories.join(',')}`;

      const cachedData = sessionStorage.getItem(storageKey);
      if (cachedData) {
        setCategories(JSON.parse(cachedData));
      } else {
        const { data } = await axios.get(
          `${endpoints.core}/categories?hierarchy=1`,
          { params: { locale } }
        );

        data.forEach((rootCategory) => {
          rootCategory.categories = rootCategory.categories.filter(
            (category) => !ignoreCategories.includes(category.id)
          );
          rootCategory.subContents = rootCategory.categories;
        });

        sessionStorage.setItem(storageKey, JSON.stringify(data));

        setCategories(data);
      }
    })();
  }, []);

  return categories;
}
